module.exports = __webpack_public_path__ + "img/isengard-3018-07-20.b8a0a239.jpg";